import styled from "@emotion/styled"
import type { RoomBranding } from "../../../../recoil/atoms/room/types"

interface StylesProps {
  roomStyles?: RoomBranding
  strokewith?: string
  isActive?: boolean
}

export const SwitcherIcon = styled.i<StylesProps>`
  font-size: 1.6rem;
  color: ${({ isActive, roomStyles }) =>
    isActive
      ? roomStyles?.accessButtonSelectedColor ?? "#edf2f7"
      : "rgba(0, 0, 0, 0.2)"};
  stroke: ${({ roomStyles, isActive }) =>
    isActive ? "white" : roomStyles?.overlayEmojiStrokeColor ?? "white"};
  stroke-width: ${({ strokewith }) => strokewith ?? "2rem"};
`

export const StyledChatIcon = styled(SwitcherIcon)`
  stroke-width: 50px;
`
